//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    &, & label, & input, & img {
        cursor: pointer;
    }
    & label {
        color: var(--dark-4);
        font-size: ${({ fontSizeLabel = "12px" }) => fontSizeLabel};
        user-select: none;
    }
    & img {
        color: var(--light-gray-2);
    }
    &.disabled {
        &, & label, & input, & img {
            pointer-events: none;
        }
        & label {
            color: var(--light-gray-4);
        }
    }
`;
export const StyledRadio = styled.input`
    display: block;
    position: relative;
    user-select: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    box-sizing: border-box;
    border: 2px solid var(--light-gray-1);
    &.error {
        border: 2px solid var(--red-3);
    }
    &.disabled {
        pointer-events: none;
        border-color: var(--light-gray-7);
    }
    &:checked {
        border: 4px solid var(--purple-2);
        &.disabled {
            border: 4px solid var(--purple-4);
        }
    }
`;